var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckGaugeHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 62,
    viewBox: "0 0 73 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5527 2.19775V8.07718",
    stroke: "#0076B6",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8951 55.4753H51.116V34.0327C51.116 32.9387 50.2381 32.0635 49.1408 32.0635H4.107C3.00969 32.0635 2.13184 32.9387 2.13184 34.0327V55.4753H6.03828",
    stroke: "#0076B6",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8795 45.7606H51.1602V37.9275H57.0418C60.2459 37.9275 62.8795 45.7606 62.8795 45.7606Z",
    stroke: "#0076B6",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7859 55.4754H70.6924V49.6115C70.6924 47.4672 68.9367 45.7168 66.7859 45.7168H51.1602V55.4754H58.973",
    stroke: "#0076B6",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8791 59.3699C65.0366 59.3699 66.7855 57.6262 66.7855 55.4752C66.7855 53.3243 65.0366 51.5806 62.8791 51.5806C60.7216 51.5806 58.9727 53.3243 58.9727 55.4752C58.9727 57.6262 60.7216 59.3699 62.8791 59.3699Z",
    stroke: "#0076B6",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98847 59.3699C12.1459 59.3699 13.8949 57.6262 13.8949 55.4752C13.8949 53.3243 12.1459 51.5806 9.98847 51.5806C7.83101 51.5806 6.08203 53.3243 6.08203 55.4752C6.08203 57.6262 7.83101 59.3699 9.98847 59.3699Z",
    stroke: "#0076B6",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57436 26.5058H2.35114L2 26.4183C2 12.9401 12.9732 2 26.4921 2C40.011 2 50.9841 12.9401 50.9841 26.4183L50.8086 26.5058H45.5854",
    stroke: "#0076B6",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7533 13.4215L9.02246 9.7019",
    stroke: "#0076B6",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4062 13.4215L44.1371 9.7019",
    stroke: "#0076B6",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2288 26.5059C28.3378 26.5059 30.0475 24.8014 30.0475 22.6988C30.0475 20.5961 28.3378 18.8916 26.2288 18.8916C24.1198 18.8916 22.4102 20.5961 22.4102 22.6988C22.4102 24.8014 24.1198 26.5059 26.2288 26.5059Z",
    stroke: "#0076B6",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2285 18.9352V12.7212",
    stroke: "#0076B6",
    strokeWidth: 3.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckGaugeHover);
export default __webpack_public_path__ + "static/media/TruckGaugeHover.c8a47985ca37b75a09e0254b9d3c8740.svg";
export { ForwardRef as ReactComponent };